import React, { useState } from 'react';

const PhoneNumberInput = ({ value, onChange, placeholder = 'N° de téléphone', countryCode = '+212' }) => {
  const [telephone, setTelephone] = useState(value || '');

  const handleTelephoneChange = (e) => {
    const newTelephone = e.target.value.replace(/\D/g, '').substring(0, 9);
    setTelephone(newTelephone);
    onChange && onChange(newTelephone); // Notify parent component if onChange is provided
  };



  return (
    <div className="form-input single-input-inner style-border">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
        }}
      >
        <span
          className="me-4"
          style={{
            position: 'absolute',
            left: 10,
            pointerEvents: 'none',
            color: '#555',
          }}
        >
          {countryCode}
        </span>
        <input
          type="tel"
          placeholder={placeholder}
          value={telephone}
          onChange={handleTelephoneChange}
          maxLength="9"
          style={{
            flex: 1,
            paddingLeft: '50px', // Make room for the "+212" to display
            border: 'none', // Remove default input border
            outline: 'none', // Remove focus outline
          }}
        />

      </div>
    </div>
  );
};

export default PhoneNumberInput;
